<template>
  <span>
    <a href="javascript:;" @click.prevent="$bvModal.show(modalId)" class="pl-1">
      <i class="fa fa-lg fa-send"></i>
    </a>
    <b-modal :id="modalId" title="Enviar reporte por correo" @show="onShow">
      <div class="text-center">
        <b-spinner v-if="loading"></b-spinner>
      </div>
      <b-form v-if="ready === true">
        <b-form-group
          label="Email"
          label-for="email"
          description="Para multiples correos, ingréselos separados por coma."
        >
          <b-form-input id="email" type="email" v-model="email" required></b-form-input>
        </b-form-group>
        <b-form-group label="CC" label-for="cc" description="Para multiples correos, ingréselos separados por coma.">
          <b-form-input id="cc" type="email" v-model="cc"></b-form-input>
        </b-form-group>
        <b-form-group label="Asunto" label-for="subject">
          <b-form-input id="subject" v-model="subject" required></b-form-input>
        </b-form-group>
        <b-form-group label="Mensaje" label-for="message">
          <b-form-textarea id="message" rows="8" v-model="message" required></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide(modalId)">Cerrar</b-button>
        <b-button variant="primary" @click.prevent="sendEmail(itemData.id)" :disabled="loading"> Enviar </b-button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "EmailModal",
  props: ["itemId", "itemData"],
  computed: {
    modalId() {
      return `email-modal-${this.itemId}`;
    }
  },
  data() {
    return {
      ready: false,
      loading: true,
      email: "",
      cc: "",
      subject: "",
      message: ""
    };
  },
  methods: {
    onShow() {
      this.loading = true;
      this.email = "";
      this.cc = "";
      this.subject = `Reporte de rechazos #${this.itemData.id}`;
      this.message = `Estimado productor, \n\nAdjunto se encuentra el reporte de rechazos #${this.itemData.id}.\n\nSaludos,\nDepartamento de calidad\nBluefield Chile`;
      this.getGrowerCompanyId(this.itemData.grower).then((id) => {
        this.email = this.getCompanyEmails(id).then(() => {
          this.loading = false;
          this.ready = true;
        });
      });
    },
    async getGrowerCompanyId(growerName) {
      this.loading = true;
      try {
        const res = await this.$axios.get(`/production/get_grower_company_id/${growerName}`);
        return res.data.grower_company_id;
      } catch (error) {
        console.log(error);
      }
    },
    async getCompanyEmails(id) {
      this.loading = true;
      try {
        const res = await this.$axios({
          method: "get",
          url: "/reports/arrival_emails/" + id
        });
        this.email = res.data.emails.to.join();
        this.cc = res.data.emails.cc.join();
      } catch (error) {
        console.log(error);
      }
    },
    sendEmail(id) {
      this.loading = true;
      const payload = {
        email: this.email,
        cc: this.cc,
        subject: this.subject,
        message: this.message
      };
      this.$axios
        .post(`/api/v1/bluefields/rechazo/${id}/email_pdf/`, payload)
        .then((response) => {
          this.$bvModal.hide(this.modalId);
          this.$bvToast.toast("Email enviado", {
            title: "Éxito",
            variant: "success",
            solid: true
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Error al enviar el email", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
